<template>
  <pr-box :title="titleBox">

    <div slot="buttons-header">
      <v-btn icon :to="{ name: 'billing-report-form', params: { id: 'new' }}" v-if="!widget">
        <v-icon color="white">add</v-icon>
      </v-btn>
    </div>

    <v-card class="pa-3">
      <v-layout row wrap>
        <v-flex xs12 md5>
          <v-text-field
            name="clientName"
            label="Cliente"
            v-model="filter.client_name"></v-text-field>
        </v-flex>
        <v-flex xs12 md5>
          <v-text-field
            name="cycleName"
            label="Nome do Ciclo"
            v-model="filter.cycle_name"></v-text-field>
        </v-flex>
        <v-flex xs12 md2>
          <v-select
            :items="cycleStatus"
            v-model="filter.cycle_status"
            item-text="description"
            item-value="value"
            clearable
            label="Status do Ciclo">
          </v-select>
        </v-flex>
        <v-flex xs12 md12 text-md-right>
          <v-btn flat color="error" @click="clearFilters()">
            <v-icon>close</v-icon>
            Limpar
          </v-btn>
          <v-btn flat color="primary" @click="search()">
            <v-icon>search</v-icon>
            Pesquisar
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>

    <div>
      <v-data-table
        :headers="headers"
        :items="resources"
        :total-items="totalResources"
        :pagination.sync="orderSync"
        :no-data-text="noDataAvailable"
        :hide-actions="true"
        :loading="searchLoading"
        class="elevation-0">

        <template slot="items" slot-scope="props">

          <td>
            {{ props.item.cycle.client.name }}
          </td>
          <td>
            {{ props.item.hours_performed }}
          </td>
          <td>
            {{ props.item.billed_hours }}
          </td>
          <td>
            {{ props.item.authorized_by }}
          </td>
          <td>
            {{ props.item.cycle.name }}
          </td>
          <td>
            <v-chip label outline :color="getColor(props.item.cycle.active)">
              {{ props.item.cycle.active.toUpperCase() === 'sim'.toUpperCase() ? 'Ativo' : 'Inativo' }}
            </v-chip>
          </td>
          <td class="text-xs-center">

            <v-btn color="primary" flat icon @click="goToForm(props.item.id)">
              <v-icon>mode_edit</v-icon>
            </v-btn>

            <v-btn flat icon color="error" @click="destroy(props.item.id, props.item.cycle.name)">
              <v-icon>delete</v-icon>
            </v-btn>

          </td>
        </template>
      </v-data-table>
      <pr-pagination :paginator="paginator"></pr-pagination>
    </div>
  </pr-box>
</template>

<script>
import CrudMixin from '@/components/mixins/CrudMixin';
import BillingReportService from '@/features/billing-report/BillingReportService';

export default {
  name: 'billing-report-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false,
    },
  },
  data() {
    return {
      cycleStatus: [
        { id: 1, description: 'ATIVO', value: 'sim' },
        { id: 2, description: 'INATIVO', value: 'nao' },
        { id: 3, description: 'TODOS', value: 'todos' },
      ],
      filter: {},
      headers: [
        {
          text: this.$t('attributes.billing_report.client'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.billing_report.hours_performed'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.billing_report.billed_hours'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.billing_report.authorized_by'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.billing_report.cycle'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.billing_report.cycle_status'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('views.fields.actions'),
          sortable: false,
          align: 'rigth',
        },
      ],
    };
  },
  methods: {
    initCrud() {
      this.serviceType = BillingReportService;
      this.routerName = 'billing-report';
    },
    applyFilters(filter) {
      return Object.assign(filter, this.filter);
    },
    getColor(cycleStatus) {
      let color = 'gray';
      if (cycleStatus.toUpperCase() === 'sim'.toUpperCase()) {
        color = 'green';
      }
      return color;
    },
    clearFilters() {
      this.filter = {};
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/features/billing-report/BillingReportList.vue